// forward-compat: not applicable — runtime-only recurrence-form enums, never
// persisted to Firestore (recurrence is stored as the rrule.format string).

export enum RecurrenceFormMode {
  RRule = 'rrule',
  Target = 'target',
}

export enum RecurrenceFormUnit {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}

export enum DayType {
  Day = 'day',
  WorkDay = 'work-day',
  WeekendDay = 'weekend',
}

export enum MonthSubMode {
  SpecificDays = 'specific-days',
  SpecificDay = 'specific-day',
}
